import React from 'react'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import SecMemories from '../../component/Page/Memories'
import Mr1 from './svg/memori/Mr1'

const Album = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className=" text-center">
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">HANDMADE WEDDING ALBUMS</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                        <h2 className="semi-bold font__size--56 text__50-1024 text__50-sm text__50-xs play">Stories are meant ‍<br />
                            ‍ to be shared</h2>
                    </div>
                </div>
            </section>


            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-xl-5 mb__5 my-lg-auto text-center text-lg-left">
                            <div className="position-relative d-inline-block">
                                <img src="./../images/hd (1).jpg" alt="" />
                                <div className="images__hd-1">
                                    <Mr1 />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 my-auto">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">ALBUMS</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="semi-bold font__size--40 text__40-1024 text__40-md text__40-mm play mb-3">The Highlight</h2>
                            <p className='normal font__size--18 text__18-1024 color__gray-1 mb-4'>This album is a great engagement session album, as a guest book for people to leave well wishes on your wedding day, and for parents gifts as well!</p>

                            <h5 className='medium font__size--24 text__24-1024  play'>SIZE</h5>
                            <p className='normal font__size--20 text__20-1024 mb-4'>The Main offers a <span className='color__brown'>8"X8"</span> spread that is the perfect size to sit on your coffee table whenever you're in the mood to relive your favorite moments.</p>
                            <h5 className='medium font__size--24 text__24-1024  play'>PAPER</h5>
                            <p className='normal font__size--20 text__20-1024 mb-4'>The <span className='color__brown'>Luster Papers</span> has a luxurious sheen and heavy duty weight will help keep your memories safe for decades.</p>
                            <h5 className='medium font__size--24 text__24-1024  play'>PAGES</h5>
                            <p className='normal font__size--20 text__20-1024 mb-4'>With <span className='color__brown'>20 pages</span>, this album is perfect for smaller weddings or engagement shoots and your most cherished memories.</p>

                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="order-lg-1 order-12 col-lg-6 my-auto">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">ALBUMS</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="semi-bold font__size--40 text__40-1024 text__40-md text__40-mm play mb-3">The Full Story</h2>
                            <p className='normal font__size--18 text__18-1024 color__gray-1 mb-4'>This album is a great engagement session album, as a guest book for people to leave well wishes on your wedding day, and for parents gifts as well!</p>

                            <h5 className='medium font__size--24 text__24-1024  play'>SIZE</h5>
                            <p className='normal font__size--20 text__20-1024 mb-4'>The Heirloom Lux offers a <span className='color__brown'>10"X10"</span> spread that is the perfect size to capture the finest details of your day.</p>
                            <h5 className='medium font__size--24 text__24-1024  play'>PAPER</h5>
                            <p className='normal font__size--20 text__20-1024 mb-4'>The <span className='color__brown'>Lux Deep Matte Paper</span> is soft to the touch and offers a timeless look you'll appreciate for decades.</p>
                            <h5 className='medium font__size--24 text__24-1024  play'>PAGES</h5>
                            <p className='normal font__size--20 text__20-1024 mb-4'>Relive the entire day with <span className='color__brown'>36 pages</span> filled with all of the favorite memories.</p>
                        </div>
                        <div className="order-1 order-lg-12 col-lg-6 col-xl-5 mb__5 my-lg-auto text-center text-lg-right">
                            <div className="position-relative d-inline-block">
                                <img src="./../images/hd (1).jpg" alt="" />
                                <div className="images__hd-2">
                                    <Mr1 />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <SecMemories  />

            <Contact />

            <Footer />
        </div >
    )
}

export default Album